import CloseIcon from '@mui/icons-material/Close'
import { Container, Grid, Modal, Slide, useMediaQuery, useTheme } from '@mui/material'
import { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { HeaderIcon } from 'src/utils/Icon'

import { observer } from 'mobx-react-lite'
import { RootStoresContext } from 'src'
import { RouterPaths } from 'src/routes/RouterPaths'
import Text from '../Text'
import { CloseBtn, LogoImg, MenuBtn, NavBtn, NavGrid, NavText, NavWrapperGrid, RelativeGrid } from './style'
import HeaderViewModel from './viewModel'

const menus = [
  { title: 'ホーム', link: RouterPaths.Home },
  { title: '電気使用量を見る', link: RouterPaths.Consumptions },
  { title: 'ご利用料金', link: RouterPaths.Invoices },
  // { title: '領収書', link: RouterPaths.Receipts },
  { title: '退去される方', link: RouterPaths.User.MoveOut },
]

const Header = () => {
  const RootStore = useContext(RootStoresContext)
  const [viewModel] = useState(new HeaderViewModel(RootStore))
  const { isLoggedIn, userName, isOpenMenu, setIsOpenMenu } = viewModel

  const navigate = useNavigate()
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('md'))
  const LogoURL = isTablet ? HeaderIcon.MobileLogo : HeaderIcon.Logo

  return (
    <Container>
      <Grid container direction="column" alignItems="center" rowSpacing={2}>
        <RelativeGrid item container direction="column" alignItems="center">
          <Grid>
            <LogoImg src={LogoURL} alt="株式会社STNet" />
          </Grid>

          {isLoggedIn && <NavBtn onClick={() => setIsOpenMenu(true)}>MENU</NavBtn>}
        </RelativeGrid>

        {isLoggedIn && (
          <Grid item container direction="column" spacing={1}>
            <Grid item>
              <Text color="white" size={13}>
                ようこそ　{userName}　様
              </Text>
            </Grid>

            <NavWrapperGrid item container direction="row" alignItems="center">
              {menus.map((menu) => (
                <NavGrid item key={menu.title} xs onClick={() => navigate(menu.link)}>
                  <NavText>{menu.title}</NavText>
                </NavGrid>
              ))}
            </NavWrapperGrid>
          </Grid>
        )}
      </Grid>

      <Modal
        open={isOpenMenu}
        slotProps={{
          backdrop: {
            transitionDuration: { appear: 500, enter: 500, exit: 1000 },
            onClick: () => setIsOpenMenu(false),
          },
        }}
      >
        <Slide
          direction="up"
          in={isOpenMenu}
          mountOnEnter
          unmountOnExit
          timeout={{ appear: 500, enter: 500, exit: 500 }}
        >
          <Grid container direction="column" spacing={2}>
            <Grid item>
              <Grid container direction="column" alignItems="flex-end">
                <Grid item>
                  <CloseBtn variant="outlined" onClick={() => setIsOpenMenu(false)}>
                    <CloseIcon /> 閉じる
                  </CloseBtn>
                </Grid>
              </Grid>
            </Grid>

            <Grid item>
              <Grid container direction="row" justifyContent="center" alignItems="center" spacing={1}>
                <Grid item>
                  <MenuBtn
                    onClick={() => {
                      setIsOpenMenu(false)
                      navigate(RouterPaths.Home)
                    }}
                  >
                    ホーム
                  </MenuBtn>
                </Grid>
                <Grid item>
                  <MenuBtn
                    onClick={() => {
                      setIsOpenMenu(false)
                      navigate(RouterPaths.Consumptions)
                    }}
                  >
                    電気
                    <br />
                    使用量を
                    <br />
                    見る
                  </MenuBtn>
                </Grid>
                <Grid item>
                  <MenuBtn
                    onClick={() => {
                      setIsOpenMenu(false)
                      navigate(RouterPaths.Invoices)
                    }}
                  >
                    ご利用
                    <br />
                    料金
                  </MenuBtn>
                </Grid>
              </Grid>
            </Grid>

            <Grid item>
              <Grid container direction="row" justifyContent="center" alignItems="center" spacing={1}>
                {/* <Grid item>
                  <MenuBtn
                    onClick={() => {
                      setIsOpenMenu(false)
                      navigate(RouterPaths.Receipts)
                    }}
                  >
                    領収書
                  </MenuBtn>
                </Grid> */}
                <Grid item>
                  <MenuBtn
                    onClick={() => {
                      setIsOpenMenu(false)
                      navigate(RouterPaths.User.MoveOut)
                    }}
                  >
                    退去
                    <br />
                    される方
                  </MenuBtn>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Slide>
      </Modal>
    </Container>
  )
}

export default observer(Header)
